import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";

import { UserContext } from "../Context/UserContext";

export const RequireResearcher = () => {
  const { userData, loading } = React.useContext(UserContext);

  let location = useLocation();
  if (loading === false) {
    if (userData?.userType?.category === "user") {
      return <Navigate to="/home" state={{ from: location }} />;
    }

    return <Outlet />;
  } else return <div>Loading...</div>;
};
